import React from 'react';
import PageContainer from '../../components/container/PageContainer';
import Navbar from '../../layouts/full-layout/header/homeHeader';
import { Box, Typography } from '@mui/material';
import Footer from '../../layouts/full-layout/footer/Footer';
import BgImage from '../../assets/backgrounds/poster.jpg';

const TermsConditions = () => {
  return (
    <PageContainer title="Terms & Conditions" description="This is Terms & Conditions Page">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {/* <Navbar /> */}

        {/* Main Content */}
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: `url(${BgImage})`, // Make sure the background image is wrapped in `url()`
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginTop: '120px',
          }}
        >
          <Typography variant="h1" fontWeight="bold">
            Terms & Conditions
          </Typography>

          <Box p={5}>
            <Typography variant="h3">
              These terms and conditions outline the rules and regulations for the use of the
              Behtar@75 Website, located at http://behtar75.in/ (hereinafter referred to as ‘
              Behtar@75’). By accessing this website we assume you accept the following terms and
              conditions. Do not continue to use Behtar@75 or any other page redirected to through
              the hyperlink, if in case, you do not agree to all of the terms and conditions stated
              herein for this page/website. The following terminology applies to these Terms and
              Conditions, Privacy Statement and Disclaimer Notice, and all Agreements: “Client”,
              “You” and “Your” refers to you, the person logs on this website and is compliant to
              the Company’s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”,
              refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and
              ourselves. All terms refer to the offer, acceptance, and consideration of payment
              necessary to undertake the process of our assistance to the Client in the most
              appropriate manner for the express purpose of meeting the Client’s needs in respect of
              the provision of the Company’s stated services, in accordance with and subject to,
              prevailing law of India. Any use of the above terminology or other words in the
              singular, plural, capitalization, and/or he/she or they, are taken as interchangeable
              and therefore as referring to the same.
            </Typography>
            <Typography variant="h2" fontWeight="bold">
              Cookies
            </Typography>
            <Typography variant="h3">
              We employ the use of cookies. By accessing Behtar@75, you agreed to use cookies in
              agreement with the Behtar@75 Privacy Policy. Most interactive websites use cookies to
              let us retrieve the user’s details for each visit. Cookies are used by our website to
              enable the functionality of certain areas to make it easier for people visiting our
              website. Some of our affiliate/advertising partners may also use cookies.
            </Typography>
            <Typography variant="h2" fontWeight="bold">
              License
            </Typography>
            <Typography variant="h3">
              Unless otherwise stated, Behtar@75 and/or its licensors own the intellectual property
              rights for all material and content on Behtar@75. All intellectual property rights are
              reserved. You may access this from Behtar@75 for your own personal use subject to
              restrictions set in these terms and conditions. You must not: republish, sell, rent or
              sub-license material from Behtar@75; reproduce, duplicate, or copy material from
              Behtar@75; Redistribute content from Behtar@75. This Agreement shall begin on the date
              hereof.
            </Typography>
            <Typography variant="h2" fontWeight="bold">
              Community & usage guidelines
            </Typography>
            <Typography variant="h3">
              Certain modules offered by Behtar@75 give an opportunity for users to post and
              exchange opinions and information in certain areas of the website and certain forums
              owned by Behtar@75. Behtar@75 does not filter, edit, publish or review Comments prior
              to their presence on the website. Comments do not reflect the views and opinions of
              Behtar@75, its agents, and/or affiliates. Comments reflect the views and opinions of
              the person who posts their views and opinions. To the extent permitted by applicable
              laws, Behtar@75 shall not be liable for the Comments or for any liability, damages, or
              expenses caused and/or suffered as a result of any use of and/or posting of and/or
              appearance of the Comments on this website. Behtar@75 reserves the right to monitor
              all Comments and to remove any Comments which can be considered inappropriate,
              offensive, or causes a breach of these Terms and Conditions. Under the various
              programs it offers, Behtar@75 may hold/host online conferences or webinars. Behtar@75
              doesn’t allow nor encourage any hate speech, discrimination, or any form of intent to
              bring harm to its members. While Behtar@75 will ensure moderation, it is not liable
              for any offense or liability caused by actions or usage of any members or
              participants. You warrant and represent that: You are not entitled to reproduce,
              republish, reuse, any material and content published on the website at
              http://behtar75.in/ and any other redirected pages or hyperlinks generated from it.
              You are not entitled to use, reproduce and republish the name and the logos of ‘
              Behtar@75’ and ‘Azadi ka amrit Mahotsav’ or reuse the trademark, wordmark used in the
              http://behtar75.in/ and any other Intellectual Properties, whatsoever.
            </Typography>
            <Typography variant="h2" fontWeight="bold">
              Reservation of Rights
            </Typography>
            <Typography variant="h3">
              We reserve the right to request that you remove all links or any particular link to
              our Website. You approve to immediately remove all links to our Website upon request.
              We also reserve the right to amend these terms and conditions and its linking policy
              at any time that shall be in force with immediate effect. By continuously linking to
              our Website, you agree to be bound to and follow these linking terms and conditions.
              Removal of links from our website If you find any link on our Website that is
              inappropriate for any reason, you are free to contact and inform us at any moment. We
              will consider requests to remove links but we are not obligated to or so or to respond
              to you directly. We do not ensure that the information on this website is correct, we
              do not warrant its completeness or accuracy; nor do we promise to ensure that the
              website remains available or that the material on the website is kept up to date.
            </Typography>
          </Box>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </PageContainer>
  );
};

export default TermsConditions;
